import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Contact() {
  useTitle({
    title: '聯絡我們｜保險建築師免費諮詢預約',
    description: '聯繫保險建築師陳琮恩，預約免費保險諮詢或加入 LINE@ 快速提問，協助您規劃最適合的保障方案。',
  });
  return (
    <main>
      <Navbar />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <ContactMap />
      <PageCta />
      <Footer />
    </main>
  );
}
